import "./SalesInvoices.css";
import React, { useEffect, useState } from "react";
import { Card, Col, Row, Spin } from "antd";
import { PageHeader } from "@ant-design/pro-layout";
import { AuditOutlined, HomeOutlined } from "@ant-design/icons";
import CustomBreadcrumb from "../../../components/CustomBreadcrumb";
import { useTranslation } from "react-i18next";
import { SaleInvoiceStatus } from "../../../configs/constants";
import { getBranches, getSaleInvoicesCount } from "../../../network/network";
import { handleApiError } from "../../../utils/errorHandler";
import DraftInvoices from "./DraftInvoices";
import OpenInvoices from "./OpenInvoices";
import PaidInvoices from "./PaidInvoices";
import AddInvoice from "./AddInvoice";

const SalesInvoices = () => {
  const [reload, setReload] = useState(false);
  const [tab, setTab] = useState([]);
  const { t } = useTranslation();
  const [count, setCount] = useState([]);
  const [branchesData, setBranchesData] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);

  useEffect(() => {
    setIsDataLoading(true);
    getBranches({ per_page: -1 })
      .then((response) => {
        if (response?.data?.success === false) {
          handleApiError(response, t);
          return;
        }

        setBranchesData(response.data.data.branches);
      })
      .catch((error) => handleApiError(error, t))
      .finally(() => {
        setIsDataLoading(false);
      });
  }, [t]);

  useEffect(() => {
    getSaleInvoicesCount()
      .then((response) => {
        if (response?.data?.success === false) {
          handleApiError(response, t);
          return;
        }

        setCount(response.data.data);
        setTab();
      })
      .catch((error) => handleApiError(error, t));
  }, [reload, t]);

  const onChangeTab = (key) => {
    setTab(key);
  };

  const breadcrumbRoutes = [
    {
      path: "/",
      breadcrumbName: t("home"),
      icon: <HomeOutlined />,
    },
    {
      path: "sales-invoice",
      breadcrumbName: t("sales_invoice"),
      icon: <AuditOutlined />,
    },
  ];

  return (
    <>
      <Card className="app-mb-20">
        <CustomBreadcrumb menus={breadcrumbRoutes} />
        <PageHeader
          className="app-p-0"
          title={t("sales_invoice")}
          ghost={false}
          extra={<AddInvoice reloadCallback={() => setReload(!reload)} />}
        />
      </Card>
      <Spin spinning={isDataLoading}>
        <Row
          gutter={[20, 20]}
          style={{ marginBottom: "20px", textAlign: "center" }}
        >
          <Col span={8}>
            <Card
              className={
                "tab_title" +
                (tab === SaleInvoiceStatus.Draft ? " active" : "")
              }
              onClick={() => onChangeTab(SaleInvoiceStatus.Draft)}
            >
              <div>
                {t("draft_invoices")}
                <span className="tab_count">
                  {count.draft_sale_invoice_count}
                </span>
              </div>
            </Card>
          </Col>
          <Col span={8}>
            <Card
              className={
                "tab_title" +
                (tab === SaleInvoiceStatus.IssueInvoice ? " active" : "")
              }
              onClick={() => onChangeTab(SaleInvoiceStatus.IssueInvoice)}
            >
              <div>
                {t("open_invoices")}
                <span className="tab_count">
                  {count.issue_sale_invoice_count}
                </span>
              </div>
            </Card>
          </Col>
          {/* <Col span={6}>
            <Card
              className={
                "tab_title" +
                (tab === SaleInvoiceStatus.PartialPaidInvoice
                  ? " active"
                  : "")
              }
              onClick={() =>
                onChangeTab(SaleInvoiceStatus.PartialPaidInvoice)
              }
            >
              <div>
                {t("partially_paid_invoices")}
                <span className="tab_count">
                  {count.partialPaid_sale_invoice_count}
                </span>
              </div>
            </Card>
          </Col> */}
          <Col span={8}>
            <Card
              className={
                "tab_title" +
                (tab === SaleInvoiceStatus.PaidInvoice ? " active" : "")
              }
              onClick={() => onChangeTab(SaleInvoiceStatus.PaidInvoice)}
            >
              <div>
                {t("paid_invoices")}
                <span className="tab_count">
                  {count.paid_sale_invoice_count}
                </span>
              </div>
            </Card>
          </Col>
        </Row>
      </Spin>
      {tab === SaleInvoiceStatus.Draft && (
        <DraftInvoices
          branchesData={branchesData}
          reloadCallback={() => setReload(!reload)}
        />
      )}
      {tab === SaleInvoiceStatus.IssueInvoice && (
        <OpenInvoices
          branchesData={branchesData}
          reloadCallback={() => setReload(!reload)}
        />
      )}
      {/* {tab === SaleInvoiceStatus.PartialPaidInvoice && (
        <PartiallyPaidInvoices
          branchesData={branchesData}
          reloadCallback={() => setReload(!reload)}
        />
      )} */}
      {tab === SaleInvoiceStatus.PaidInvoice && (
        <PaidInvoices
          branchesData={branchesData}
          reloadCallback={() => setReload(!reload)}
        />
      )}
    </>
  );
};

export default SalesInvoices;
